import { PartnersType } from '../Subscription/PartnersType';

const SepteoProspectType = {
    vendor: '2' as ProspectTypeValues,
    buyer: '17' as ProspectTypeValues,
    owner: '24' as ProspectTypeValues,
    prospect: '29' as ProspectTypeValues,
} as const;

const OrishaProspectType = {
    buyer: '1' as ProspectTypeValues,
    seller: '2' as ProspectTypeValues,
    landlord: '19' as ProspectTypeValues,
} as const;

const septeoProspectTypeAsString = (type: ProspectType | string): string => {
    switch (type) {
        case SepteoProspectType.buyer:
            return 'Acquéreur';
        case SepteoProspectType.vendor:
            return 'Vendeur';
        case SepteoProspectType.owner:
            return 'Propriétaire';
        case SepteoProspectType.prospect:
            return 'Prospect';
        default:
            return type.toString();
    }
};

const orishaProspectTypeAsString = (type: ProspectType | string): string => {
    switch (type) {
        case OrishaProspectType.buyer:
            return 'Demandeur';
        case OrishaProspectType.seller:
            return 'Vendeur';
        case OrishaProspectType.landlord:
            return 'Propriétaire';
        default:
            return type.toString();
    }
};

export type ProspectTypeValues = string;

export type ProspectType = typeof ProspectType[keyof typeof ProspectType];

export const ProspectType = {
    [PartnersType.septeo]: SepteoProspectType,
    [PartnersType.orisha]: OrishaProspectType,
};

export const prospectTypeAsString = (type: ProspectType | string, partnerType: PartnersType): string => {
    switch (partnerType) {
        case PartnersType.septeo:
            return septeoProspectTypeAsString(type);
        case PartnersType.orisha:
            return orishaProspectTypeAsString(type);
        default:
            return septeoProspectTypeAsString(type);
    }
};
